/**
 * PendingAudioList
 * ────────────────
 * Recordings that were synced (device / mobile) but not transcribed yet —
 * Auto Sync sessions parked as `awaiting_transcribe`. Shown inside the Auto
 * Sync modal; picking one lets the teacher add board photos and a reference
 * document before hitting Transcribe.
 */
import React from 'react';
import { Mic, ChevronRight } from 'lucide-react';

export const isAwaitingTranscribe = (item) => item?.smart_note_status === 'awaiting_transcribe';

export function recordedAtLabel(item) {
  const raw = item?.recorded_at || item?.created_at;
  if (!raw) return '';
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleString(undefined, {
    day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', hour12: true,
  });
}

export function pendingTitle(item) {
  return item?.title_hint || item?.original_filename || 'Recording';
}

export default function PendingAudioList({ items, onSelect, disabled }) {
  if (!items?.length) return null;
  return (
    <div className="rounded-2xl border border-emerald-200 bg-emerald-50/40 p-4" data-testid="auto-sync-pending-list">
      <div className="text-[11px] uppercase tracking-widest font-bold text-emerald-800 mb-2">
        Recorded · not transcribed yet · {items.length}
      </div>
      <div className="grid gap-2">
        {items.map(item => (
          <button
            key={item.id}
            type="button"
            onClick={() => onSelect(item)}
            disabled={disabled}
            data-testid={`auto-sync-pending-${item.id}`}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl bg-white border border-zinc-200 hover:border-emerald-300 hover:bg-emerald-50/60 text-left transition-all disabled:opacity-50">
            <div className="w-8 h-8 rounded-lg bg-emerald-100 text-emerald-700 flex items-center justify-center flex-shrink-0">
              <Mic className="w-4 h-4" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-[13px] font-bold text-slate-900 truncate">{pendingTitle(item)}</div>
              <div className="text-[11px] text-slate-500">Recorded {recordedAtLabel(item)}</div>
            </div>
            <ChevronRight className="w-4 h-4 text-slate-400" />
          </button>
        ))}
      </div>
      <p className="text-[11px] text-slate-500 mt-2">Pick a recording to add board photos and a reference, then Transcribe — or record / upload a new one below.</p>
    </div>
  );
}
